// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"313":"3b989627","850":"f6cbef04"}[chunkId] + ".chunk.js";
};